import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVdiTransaction } from '@/services/vdiTransaction/vdiTransaction.type';
import {
  ApiResponse,
  CreateProvider,
  DeleteProvider,
  Provider,
} from '../sagas/providerSaga';
import { ISingleVdiResponse } from '../sagas/vdiTransactionSaga';

export interface VdiTransactionState {
  vditransactions: ApiResponse;
  loading: boolean;
  error: boolean;
  singleLoading: boolean;
  singleSuccess: boolean;
  singleError: boolean;
  vditransaction: ISingleVdiResponse;
}

export const initialState: VdiTransactionState = {
  vditransactions: {
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalItems: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: '',
  },
  loading: false,
  error: false,
  singleLoading: false,
  singleSuccess: false,
  singleError: false,
  vditransaction: {
    success: false,
    message: '',
    data: [] as any,
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalItems: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
  },
};

const providerSlice = createSlice({
  name: 'vditransaction',
  initialState,
  reducers: {
    getVditransactions: (state) => {
      state.loading = true;
    },
    getVditransactionsSuccess: (state, action: PayloadAction<ApiResponse>) => {
      state.loading = false;
      state.vditransactions = { ...action.payload };
    },
    getVditransactionsFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    getVditransaction: (state, action: PayloadAction<IVdiTransaction>) => {
      state.singleLoading = true;
      state.singleSuccess = false;
      state.singleError = false;
    },
    getVditransactionSuccess: (state, action: PayloadAction<Provider>) => {
      state.singleLoading = false;
      state.singleSuccess = true;
      state.singleError = false;
      state.vditransaction = { ...action.payload } as unknown as ISingleVdiResponse; // Avoid direct assignment, create a new object
    },
    getVditransactionFailure: (state) => {
      state.singleLoading = false;
      state.singleSuccess = false;
      state.singleError = true;
    },
    createVditransaction: (state, action: PayloadAction<CreateProvider>) => {
      state.loading = true;
    },
    createVditransactionSuccess: (state, action: PayloadAction<Provider>) => {
      state.loading = false;
      state.vditransaction = { ...action.payload } as unknown as ISingleVdiResponse; // Avoid direct assignment, create a new object
    },
    createVditransactionFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    updateVditransaction: (state, action: PayloadAction<CreateProvider>) => {
      state.loading = true;
    },
    updateVditransactionSuccess: (state, action: PayloadAction<Provider>) => {
      state.loading = false;
      state.vditransaction = { ...action.payload } as unknown as ISingleVdiResponse; // Avoid direct assignment, create a new object
    },
    updateVditransactionFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    deleteVditransaction: (state, action: PayloadAction<DeleteProvider>) => {
      state.loading = true;
    },
    deleteVditransactionSuccess: (state, action: PayloadAction<Provider>) => {
      state.loading = false;
      state = {
        ...state,
        vditransactions: {
          ...state.vditransactions,
          data: state.vditransactions.data.filter(
            (item) =>
              (item as any)?.vdiTransactionId !== (action?.payload as any)?.vdiTransactionId,
          ),
        },
      }; // Avoid direct assignment, create a new object
    },
    deleteVditransactionFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    resetVditransactions: (state) => {
      state.vditransactions = initialState.vditransactions;
      state.singleLoading = initialState.singleLoading;
      state.singleSuccess = initialState.singleSuccess;
      state.singleError = initialState.singleError;
    },
  },
});

const VditransactionReducer = providerSlice.reducer;
export const {
  getVditransactions,
  getVditransactionsSuccess,
  getVditransactionsFailure,
  getVditransaction,
  getVditransactionSuccess,
  getVditransactionFailure,
  createVditransaction,
  createVditransactionSuccess,
  createVditransactionFailure,
  updateVditransaction,
  updateVditransactionSuccess,
  updateVditransactionFailure,
  deleteVditransaction,
  deleteVditransactionSuccess,
  deleteVditransactionFailure,
  resetVditransactions,
} = providerSlice.actions;
export default VditransactionReducer;
